
<div mat-dialog-content>
  <h1>{{data.title}}</h1>
  <p>{{data.subtitle}}</p>

  <mat-form-field *ngIf="data.type == 'text'" color="accent">
    <input matInput [(ngModel)]="data.currentValue">
  </mat-form-field>

  <input *ngIf="data.type == 'color'"
         matInput
         autocomplete="new-colo"
         placeholder="Toucher ici"
         type="text"
         [(colorPicker)]="data.currentValue"
         [cpPosition]="'bottom'"
         [style.background]="data.currentValue"
         class="color-input"
         name="color">

  <section *ngIf="data.elemType == 'folder'">
    <ng-container *ngFor="let lang of data.elemLang">
      <div *ngIf="lang.tag != 'fr'">
        <input matInput [placeholder]="lang.tag" [(ngModel)]="lang.value" type="text">

      </div>
    </ng-container>
  </section>

  <section *ngIf="data.type=='webpage'">
    <mat-form-field color="accent">
      <input matInput placeholder="{{'buttonText' | translation}}" [(ngModel)]="data.item.name">
    </mat-form-field>

    <mat-form-field color="accent">
      <input matInput placeholder="{{'urlText' | translation}}" [(ngModel)]="data.item.url">
    </mat-form-field>
    <div *ngFor="let item of data.complement">
      <mat-form-field *ngIf="item.value == undefined">
        <input matInput [placeholder]="item.name" [(ngModel)]="data.item[item.name]" *ngIf="item.type != 'range'" [type]="item.type">
        <input matInput [placeholder]="item.name" [(ngModel)]="data.item[item.name]" *ngIf="item.type == 'range'" type="textfield">
      </mat-form-field>

      <div *ngIf="item.value != undefined">
        <p>{{item.name}}</p>
        <div *ngFor="let val of item.value">
          <button [class.activeElement]="val == data.item[item.name]" (click)="setData(item.name, val)">{{val}}</button>
        </div>
      </div>

    </div>




    <input type="file" class="inputFile" (change)="onChange($event)" id="file" name="file">


  </section>

  <section *ngIf="data.type == 'lottery'">

    <div class="dataTextInputContainer">


      <div class="dataTextInput">
        <mat-label>{{'prizeName' | translation}}</mat-label>
        <mat-form-field color="accent">
          <input matInput class="form-control" [(ngModel)]="data.name">
        </mat-form-field>
      </div>
      <div class="dataTextInput">
        <mat-label>{{'quantityPrize' | translation}}</mat-label>
        <mat-form-field color="accent" *ngIf=" data.index != 0">
          <input matInput (keypress)="numberOnly($event)" [disabled]="!data.winner || data.index == 0" [value]="0" class="form-control" type="number" [(ngModel)]="data.quantity">
        </mat-form-field>
      </div>
      <div class="dataTextInput">
        <mat-label>{{'winningPrizeText' | translation}}</mat-label>
        <mat-form-field color="accent">
          <input matInput class="form-control" type="text" [(ngModel)]="data.winningText">
        </mat-form-field>
      </div>


      <ng-container color="accent" *ngIf="data.gameType == 'wheel' || data.gameType == undefined">
        <div class="colorSelect">
          <mat-label>{{'color' | translation}}</mat-label>
          <input matInput placeholder="" [(colorPicker)]="data.color"
                 [style.background]="data.color" type="text" name="color" class="color-input">
        </div>
      </ng-container>
      <mat-divider [inset]="true"></mat-divider>
    </div>

    <div class="uploadFile">


      <div class="uploadAudioFile">
        <div class="uploadLotteryFile" *ngIf="_sharedVar.checkAppVersion('1.21.0', 'media')">
          <div class="uploadLotteryFileContent">
            <h3>Son de fin</h3>

            <audio *ngIf="data.endSound" controls>
              <source>
              <source [src]="data.endSound.url" type="audio/mpeg">
              Your browser does not support the audio element.
            </audio>

            <input type="file" class="inputFile" (change)="onEndSoundChange($event)" id="file" name="file" accept=".mp3" />
            <button *ngIf="data.endSound" (click)="deleteFile(data.endSound.url, 'endSound')"> <mat-icon>delete</mat-icon></button>
          </div>
          <div>

          </div>
        </div>
        <mat-divider [inset]="true"></mat-divider>
      </div>
      <div class="uploadVisualFile">


        <div class="uploadLotteryFile" *ngIf="data.gameType == 'slot' && data.index != 0">
          <div class="uploadLotteryFileContent">


            <h3>Image du lot</h3>


            <img *ngIf="data.imgData" [src]="data.imgData.url" />

            <input type="file" class="inputFile" (change)="onSlotImageChange($event)" id="file" name="file" />

          </div>
          <div>
          </div>
        </div>

        <div class="uploadLotteryFile">
          <div class="uploadLotteryFileContent">

            <h3>Média de fin</h3>

            <ng-container *ngIf="data.endImgData && !data.endImgData.url.includes('.mp4')">
              <img [src]="data.endImgData.url" />

            </ng-container>
            <ng-container *ngIf="data.endImgData && data.endImgData.url.includes('.mp4')">
              <div>
                <mat-icon>play_circle_outline</mat-icon>
              </div>
              <ng-container *ngIf="data.endImgData.defaultName; else generatedName">
                <mat-label>{{data.endImgData.defaultName}}</mat-label>

              </ng-container>
              <ng-template #generatedName>
                <mat-label>{{data.endImgData.name}}</mat-label>
              </ng-template>
            </ng-container>
            <input type="file" class="inputFile" (change)="onEndImageChange($event)" id="file" name="file" />
            <button *ngIf="data.endImgData" (click)="deleteFile(data.endImgData.url, 'endImgData')"> <mat-icon>delete</mat-icon></button>

          </div>
          <div>


          </div>
        </div>

      </div>
      <mat-divider [inset]="true"></mat-divider>

    </div>

    <div class="booleanContainer">
      <div fxLayout="row" fxLayoutAlign="space-around center" *ngIf="data.index != 0">
        <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="data.winner" [disabled]="data.index == 0" (ngModelChange)="setValue()">
          {{'isWinner' | translation}}
        </mat-slide-toggle>

        <mat-slide-toggle *ngIf="canAccessSpecialPrize()" color="accent" type="checkbox" [(ngModel)]="data.special" [disabled]="data.index == 0" (ngModelChange)="setValue()">
          {{ 'specialPrize' | translation }}
        </mat-slide-toggle>
      </div>
    </div>
    <!-- <mat-form-field color="accent">
      <input matInput placeholder="Label du lot" [(ngModel)]="data.name">
    </mat-form-field>-->
  </section>




</div>


<div mat-dialog-actions>

  <button mat-raised-button color="{{data.buttonColor}}" [mat-dialog-close]="data" cdkFocusInitial>{{data.buttonLabel}}</button>
  <button mat-raised-button color="primary" (click)="onNoClick()">{{'cancel' | translation}}</button>
</div>

